import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { IPermissionRole } from 'src/app/authentication/models/permission-role';
import { RoleService } from 'src/app/authentication/services/role.service';
import { UniqueNameValidator } from 'src/app/shared/validators/uniqueName.validator';

@Component({
    selector: 'app-permission-roles',
    templateUrl: './permission-roles.component.html',
    styleUrls: ['./permission-roles.component.css'],
    standalone: false
})
export class PermissionRolesComponent implements OnInit {
  constructor(
    private route : ActivatedRoute,
    private permissionRoleService : RoleService
  ) { }

  permissionRoles : IPermissionRole[] = [];


  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;



  ngOnInit(): void {
    this.permissionRoles = this.route.snapshot.data.roles as IPermissionRole[];
  }

  updateList(){
    this.permissionRoleService.listRoles({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.permissionRoles = response;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, [
        Validators.required,
        UniqueNameValidator(() => this.permissionRoles.map(r => r.name)),
      ]),
      description: new UntypedFormControl(null),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, [
        Validators.required,
        UniqueNameValidator(() => this.permissionRoles.filter(r => r.id !== dataItem.id).map(r => r.name)),
      ]),
      description: new UntypedFormControl(dataItem.description),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const id = event.dataItem.id ?? null;
    const request: any = {
      name: event.formGroup.value.name?.trim(),
      description: event.formGroup.value.description,
      id,
    }

    // Create and update are separate endpoints - POST rejects a request that carries an id.
    const save$ = id
      ? this.permissionRoleService.updateRole(request)
      : this.permissionRoleService.createRole(request);

    // Close the row only on success, so the input survives a rejected save (errors are shown by the interceptor).
    save$.subscribe(response => {
      event.sender.closeRow(event.rowIndex);
      this.updateList();
    });
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.permissionRoleService.deleteRole(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }

}
